/**
 *  @class
 *  @function RecentlyViewedProducts
 */
/**
 *  @class
 *  @function RecentlyViewedProducts
 */
if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();

      this.url = `${theme.routes.search_url}?view=recently-viewed&type=product&q=`;
      this.container = this.querySelector('.products');
      this.currentId = this.dataset.productHandle;
      this.max = Number(this.dataset.max);
      this.products = '';
      this.productHandles = [];
      const recentIds = window.localStorage.getItem('recently-viewed');
      if (recentIds) {
        try {
          window.recentlyViewedIds = JSON.parse(recentIds);
        } catch (e) {
          window.localStorage.removeItem('recently-viewed');
        }
      }
    }

    connectedCallback() {
      this.buildUrl();
    }

    buildUrl() {
      if (!window.recentlyViewedIds || !Array.isArray(window.recentlyViewedIds) || window.recentlyViewedIds.length === 0) {
        return;
      }
      this.productHandles = window.recentlyViewedIds.filter(val => val !== this.currentId).slice(0, this.max);
      if (this.productHandles.length === 0) {
        return;
      }
      this.products = this.productHandles.map(handle => `handle:${handle}`).join(' OR ');
      this.url += encodeURIComponent(this.products);

      this.fetchProducts();
    }

    fetchProducts() {
      fetch(this.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.products');

          if (recommendations && recommendations.innerHTML.trim().length) {
            // Sort products by the order in productHandles
            const productCards = Array.from(recommendations.querySelectorAll('.carousel__slide'));
            const sortedCards = this.sortProductsByHandleOrder(productCards, this.productHandles);

            // Clear and re-add sorted products
            this.container.innerHTML = '';
            sortedCards.forEach(card => this.container.appendChild(card));

            this.classList.add('recently-viewed-products--loaded');
            this.container.querySelectorAll('.lazyload').forEach((image) => {
              lazySizes.loader.unveil(image);
            });

            // Reinitialize theme-scroll after adding products
            const themeScroll = this.querySelector('theme-scroll');
            if (themeScroll && typeof themeScroll.setSlides === 'function') {
              themeScroll.setSlides();
              themeScroll.init();
            }
            // Trigger resize to update layout
            window.dispatchEvent(new Event('resize'));
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    sortProductsByHandleOrder(productCards, handleOrder) {
      return productCards.sort((a, b) => {
        const handleA = this.getHandleFromCard(a);
        const handleB = this.getHandleFromCard(b);
        const indexA = handleOrder.indexOf(handleA);
        const indexB = handleOrder.indexOf(handleB);
        // If handle not found, put it at the end
        return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
      });
    }

    getHandleFromCard(card) {
      // Try to get handle from product card link
      const link = card.querySelector('a[href*="/products/"]');
      if (link) {
        const href = link.getAttribute('href');
        const match = href.match(/\/products\/([^?/]+)/);
        if (match) {
          return match[1];
        }
      }
      return '';
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
